import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
    },
    sectionHeader: {
      color: theme.gray800,
      display: "block",
      fontSize: "16px",
      fontWeight: 500,
    },
    fullWidth: {
      width: "100%",
    },
    zeroPadding: { padding: "0 !important" },
    checkboxTopPadding: {
      "&.MuiGrid-item": {
        paddingTop: theme.spacing(6),
      },
    },
    inputInfo: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: "0.4px",
      color: theme.gray400,
      marginTop: "12px",
    },
    link: {
      fontSize: "14px",
      fontWeight: 500,
    },
    OLPaper: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(12),
      marginBottom: theme.spacing(12),
      marginTop: theme.spacing(8),
      padding: theme.spacing(12),
    },
    addTranslation: {
      color: theme.gray500,
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },
    grid: {
      alignItems: "center",
      marginTop: theme.spacing(5),
      [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(0),
      },
    },
    marginZero: {
      margin: 0,
    },
    fieldName: {
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: theme.spacing(0.2),
      color: theme.gray500,
      marginBottom: theme.spacing(4),
    },
  }),
);
